(function () {
  'use strict';

  angular.module('wsLrs.services').
  /**
   * Simple definition service for the dynamic user object
   */
  factory('DynamicUser', [function () {
    var defaultName = 'Logged In User';
    var self = {
      name: defaultName,
      id: -1,
      personas: [],
      // This ensures the dynamic user isn't interpreted as a group
      setName: function setName(name) {
        this.name = name ? name : defaultName;
      },
      getCopy: function getCopy() {
        return Object.assign({}, self);
      }
    };
    return self;
  }]);
})();
